import React, {Fragment, SyntheticEvent, useState} from "react";
import DialogContent from "@mui/material/DialogContent";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {s_char, s_char_disciplines} from "../../_signals/s_char";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import {DisziplinesAvailable} from "./DisziplinesAvailable";
import {v4} from "uuid";
import {useSignals} from "@preact/signals-react/runtime";
import {ICharDiscipline} from "../../_interfaces/ICharDiscipline";
import apiAddress from "../../_sig_api/_apiadress";
import createOptions from "../../_helper/createOptions";
import {s_app_cid} from "../../_signals/s_app";
import Stack from "@mui/material/Stack";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import {DisciplinesSubscriber} from "../../_helper/DataBehaves";
import {InfoDisciplineBehaveSubscriber} from "../../_helper/InfoDisciplineBehave";
import IconButton from "@mui/material/IconButton";
import {DisziplineTalents} from "./DisziplineTalents";
import {DisciplinesCreate, IDisciplinesAdd} from "../../_api/BEDisciplines";

interface IProp {
    open: boolean,
    isOpen: (open: boolean) => void
}

function DisziplinesAdd({open, isOpen}: IProp) {
    useSignals()

    const [name, setName] = useState('')

    const addDiszipline = () => {
        let disciplines = s_char_disciplines.value;

        const add: IDisciplinesAdd = {
            id: v4(),
            cid: s_app_cid.value,
            name: name,
            circle: 0,
            num: (disciplines.length + 1)
        }
        disciplines.unshift(add);

        s_char_disciplines.value = disciplines;
        DisciplinesCreate(add).then(r => isOpen(false))
    }

    const handleDisciplinePopOpen = (name: string, e: SyntheticEvent) => {
        e.stopPropagation()
        const discipline = DisciplinesSubscriber.value.find((d) => d.name === name)
        if (discipline) {
            InfoDisciplineBehaveSubscriber.next({popOpen: true, popEl: e.currentTarget, pop: discipline})
        }
    }

    return <Fragment>
        <Dialog open={open}>
            <DialogContent>
                {s_char_disciplines.value.length === 0 ? 'Erste ' : null}
                {s_char_disciplines.value.length === 1 ? 'Zweite ' : null}
                {s_char_disciplines.value.length === 2 ? 'Dritte ' : null}
                Disziplin:
                <FormControl variant="standard"
                             size="small"
                             style={{width: '100%'}}>
                    <Select key={v4()}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            renderValue={(selected) => selected.toString()}
                    >
                        {DisziplinesAvailable.map(disziplin => {
                            const index = s_char_disciplines.value.map(function (e) {
                                return e.name;
                            }).indexOf(disziplin);
                            if (index < 0) return <MenuItem key={v4()} value={disziplin}>
                                <Stack style={{width: '100%'}} direction={'row'} justifyContent={'space-between'}>
                                    <Button variant={'outlined'} size={'small'}
                                            sx={{ textTransform: 'none',justifyContent: 'flex-start', width: '100%' }}
                                    >{disziplin}</Button>
                                    <Button variant={'outlined'} size={'small'}
                                                onClick={(e) =>
                                        handleDisciplinePopOpen(disziplin, e)}>
                                        <QuestionMarkIcon/>
                                    </Button>
                                </Stack>
                            </MenuItem>
                            else return null;
                        })
                        }
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => addDiszipline()}><CheckIcon/></Button>
                <Button onClick={() => isOpen(false)}><ClearIcon/></Button>
            </DialogActions>
        </Dialog>
    </Fragment>
}

export default DisziplinesAdd